export default "__VITE_ASSET__DWIkx_Ot__";